import {REHYDRATE} from 'redux-persist';

const initialState = {
  tableauToken: null,
  fetchingTableauToken: false,
  buyFertilizerModalIsVisible: false,
  locations: [],
  locationsDropDownListDataSource: [],
  selectedLocation: {},
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.agronomy,
          tableauToken: null,
          fetchingTableauToken: false,
          buyFertilizerModalIsVisible: false,
          locations: [],
          locationsDropDownListDataSource: [],
          selectedLocation: {},
        };
      }
      return state;

    case 'CLEAR_AGRONOMY_TABLEAU_TOKEN':
      return {
        ...state,
        tableauToken: null,
      };

    case 'FETCH_AGRONOMY_TABLEAU_TOKEN_STARTED':
      return {
        ...state,
        fetchingTableauToken: true,
      };

    case 'FETCHED_AGRONOMY_TABLEAU_TOKEN':
      return {
        ...state,
        tableauToken: action.token,
        fetchingTableauToken: false,
      };

    case 'FETCH_AGRONOMY_TABLEAU_TOKEN_FAILED':
      return {
        ...state,
        fetchingTableauToken: false,
      };

    case 'SHOW_BUY_FERTILIZER_MODAL':
      return {
        ...state,
        buyFertilizerModalIsVisible: true,
      };

    case 'HIDE_BUY_FERTILIZER_MODAL':
      return {
        ...state,
        buyFertilizerModalIsVisible: false,
      };

    case 'FETCHED_CASH_BID_LOCATIONS_WITHOUT_FUTURES':
      var locationsDropDownListDataSource = ['Select a Location'];
      action.locations.forEach((location) => {
        locationsDropDownListDataSource.push({
          label: location.location,
          value: location.locationId,
        });
      });
      return {
        ...state,
        locations: action.locations,
        locationsDropDownListDataSource: locationsDropDownListDataSource,
      };

    case 'USER_SELECTED_AGRONOMY_CASH_BID_LOCATION':
      return {
        ...state,
        selectedLocation: action.location,
      };

    default:
      return state;
  }
}
